import React, { useRef } from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import moment from 'moment';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useComponentOrderState } from '../ComponentProvider';
import { checkArray } from '../../../Components/helper';
import Loader from '../../../Components/Utility/Loader/Loader';
import * as componentAction from '../store/component.action';
import POPreviewModal from '../AddEditPOTemplate/table/PreviewModal';
import { InfoIcon, DuplicateIcon, PreviewIcon, EditIcon, DeleteIcon, ActiveIcon, InactiveIcon, SortIcon, ChevronIcon } from '../../../bombiix-icon';
import { NewCheckbox } from '../../../Components/PIM/common';

function POTable({ handleSingleDelete }) {
  const dispatch = useDispatch();
  const listInnerRef = useRef();
  const { t } = useTranslation('common');
  const { Componentstate, handleCheckAll, isallChecked, handleCheckTemplate, handlePageNextInScroll, onSortColumn, setComponentState } =
    useComponentOrderState();

  const { templateListData, selectedTemplate, isPageLoader } = Componentstate;

  const showCreatedandModified = (item) => {
    return (
      <button className="btn btn-action-icon p-0" style={{ margin: 0, fontSize: 0 }} type="button">
        <div className="info-container testing-action-spaceremoval">
          <InfoIcon size={24} />
          <div className="info-content">
            {item?.createdBy?.firstName && (
              <p className="text-left m-0">
                <strong>{t('ADD_PO_TEMPLATE_PROVIDER.CREATED')}</strong> : {`${item.createdBy?.firstName} ${item.createdBy?.lastName} | `}
                {moment(item.createdAt).format('DD-MMMM-YYYY, h:mm a')}
              </p>
            )}
            {item?.modifiedBy && (
              <p className="text-left m-0">
                <strong>{t('ADD_PO_TEMPLATE_PROVIDER.MODIFIED')}</strong> : {`${item.modifiedBy?.firstName} ${item.modifiedBy?.lastName} | `}
                {moment(item?.lastModifiedAt).format('DD-MMMM-YYYY, h:mm a')}
              </p>
            )}
          </div>
        </div>
      </button>
    );
  };

  const forAscandDesc = () => {
    return Componentstate?.sortOrder === 'Asc' ? <ChevronIcon size={24} className="ml-1 align-middle icon-inverse" /> : <ChevronIcon size={24} className="ml-1 align-middle" />;
  };

  const iconsChange = () => {
    return Componentstate?.sortOrder === '' ? <SortIcon size={24} className="ml-1 align-middle" /> : forAscandDesc();
  };

  const handlePreview = async (element) => {
    setComponentState((prevState) => ({
      ...prevState,
      loader: true,
      openPreviewModal: true,
    }));
    const res = await dispatch(componentAction.fetchEditTemplate(element?._id));
    if (res) {
      setComponentState((prevState) => ({
        ...prevState,
        loader: false,
      }));
    }
  };

  const handlePreviewToggle = async () => {
    setComponentState((prevState) => ({
      ...prevState,
      openPreviewModal: false,
    }));
    await dispatch(componentAction.clearReducer());
  };
  const activeInactiveClicked = async (ele) => {
    const data = {
      image: ele?.image,
      name: ele?.name,
      isActive: !ele?.isActive,
      templateJsonSchema: JSON.stringify(ele?.templateJsonSchema),
      _id: ele?._id,
      createdBy: ele?.createdBy,
      createdAt: ele?.createdAt,
      modifiedBy: ele?.modifiedBy,
    };
    const res = await dispatch(componentAction.editPOTemplate(ele?._id, data, t));

    if (res) {
      const reqObj = {
        pageIndex: 1,
        pageSize: Componentstate?.pageSize,
      };
      if (Componentstate.searchText) {
        reqObj.searchText = Componentstate.searchText;
      }

      if (Componentstate.sortOrder) {
        reqObj.sortOrder = Componentstate?.sortOrde;
        reqObj.sortPropertyName = Componentstate?.sortPropertyName;
      }
      setComponentState((prevState) => ({
        ...prevState,
        templateListData: [],
        selectedTemplate: [],
        pageIndex: 1,
      }));
      await dispatch(componentAction.clearReducer());
      await dispatch(componentAction.fetchPOTemplateList(reqObj));
    }
  };

  return (
    <Container fluid className="py-4 h-100 overflow-hidden">
      <div
        id="scrollableDiv_PIM"
        style={{
          height: '100%',
          overflow: 'auto',
        }}
        ref={listInnerRef}
      >
        <InfiniteScroll
          dataLength={templateListData?.length}
          loader={isPageLoader && <Loader />}
          hasMore={Componentstate?.hasMore}
          next={handlePageNextInScroll}
          scrollableTarget="scrollableDiv_PIM"
          className="fixed-col-container"
        >
          <table className="table custom-table m-0">
            <thead>
              <tr>
                <th className="w-50px">
                  <div className="d-flex justify-content-center">
                    <NewCheckbox id="check_all_symbol" name="check_all_symbol" checked={isallChecked} onChange={(e) => handleCheckAll(e)} />
                  </div>
                </th>
                <th
                  className="cursor-pointer w-100 text-left"
                  onClick={() => {
                    onSortColumn('name');
                  }}
                >
                  {t('ADD_PO_TEMPLATE_PROVIDER.PO_NAME')}
                  {Componentstate?.sortPropertyName === 'name' ? <>{iconsChange()}</> : <SortIcon size={24} className="ml-1 align-middle" />}
                </th>
                <th className="text-nowrap">{t('ADD_PO_TEMPLATE_PROVIDER.ACTIONS')}</th>
              </tr>
            </thead>
            <tbody>
              {checkArray(templateListData) ? (
                templateListData.map((ele, i) => {
                  return (
                    <tr key={ele._id}>
                      <td>
                        <div className="d-flex justify-content-center">
                          <NewCheckbox
                            id={`symbol_${i}`}
                            name={`symbol_${i}`}
                            checked={selectedTemplate?.includes(ele._id)}
                            onChange={(e) => handleCheckTemplate(e.target.checked, ele._id)}
                          />
                        </div>
                      </td>
                      <td>{ele?.name}</td>

                      <td>
                        <div className="d-flex align-items-center justify-content-center">
                          <Link
                            title={t('ADD_PO_TEMPLATE_PROVIDER.DUPLICATE')}
                            className="cursor-pointer text-dark text-decoration-none btn-tbl-action"
                            to={`/component-order/po-template/create-po-template/${ele?._id}/?forDuplication=true`}
                          >
                            <DuplicateIcon size={24} />
                          </Link>

                          <button className="btn-tbl-action" title={t('USER_GROUP_VIEW.PREVIEW')} onClick={() => handlePreview(ele)} type="button">
                            <PreviewIcon size={24} />
                          </button>

                          <Link
                            title={t('ADD_PO_TEMPLATE_PROVIDER.EDITS')}
                            className="cursor-pointer text-dark text-decoration-none btn-tbl-action"
                            to={`/component-order/po-template/create-po-template/${ele?._id}`}
                          >
                            <EditIcon size={24} />
                          </Link>

                          <button
                            className="btn-tbl-action"
                            title={t('SPEC_TEMP_LIBRARY.DELETE')}
                            onClick={() => {
                              handleSingleDelete(ele._id);
                            }}
                            type="button"
                          >
                            <DeleteIcon size={24} />
                          </button>

                          <button
                            className="btn-tbl-action mr-0 d-flex"
                            onClick={() => activeInactiveClicked(ele)}
                            title={ele.isActive ? t('USER_GROUP_VIEW.ACTIVE') : t('USER_GROUP_VIEW.INACTIVE')}
                            id={ele._id}
                            type="button"
                          >
                            {ele.isActive ? <ActiveIcon size={24} className="color-green" /> : <InactiveIcon size={24} className="color-red" />}
                          </button>
                          {showCreatedandModified(ele)}
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={3}>
                    <span className="align-items-center justify-content-center d-flex">{t('ADD_PO_TEMPLATE_PROVIDER.TEMPLATE_NOT_FOUND')}</span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </InfiniteScroll>
      </div>
      {Componentstate?.openPreviewModal && (
        <POPreviewModal
          onOpen={Componentstate?.openPreviewModal}
          toggle={handlePreviewToggle}
          data={Componentstate?.previewData}
          loading={Componentstate?.loader}
        />
      )}
    </Container>
  );
}

export default POTable;
